import { Profession } from '@/enums/profession';
import type { TaskProfession } from '@/types/data';

const midnightTaskQuests = [
    93697, // ??
    93698, // Splintered Radiance
    93699, // A Ray of Sunlight
];

export const midnightEnchanting: TaskProfession = {
    id: Profession.Enchanting,
    subProfessionId: 2909,
    treatiseQuest: {
        itemId: 245759, // Thalassian Treatise on Enchanting
        questId: 95129,
    },
    taskQuests: midnightTaskQuests.map((questId) => ({
        itemId: 263464, // Thalassian Enchanter's Folio
        questId,
    })),
    dropQuests: [
        {
            itemId: 259193, // Lost Thalassian Vellum
            questId: 93533,
            source: 'Mobs/Treasures',
        },
        {
            itemId: 259192, // Voidstorm Ashes
            questId: 93532,
            source: 'Mobs/Treasures',
        },
    ],
    gatherQuests: [
        {
            itemId: 267654, // Swirling Arcane Essence
            questId: 95048,
            source: 'Disenchanting',
        },
        {
            itemId: 267654, // Swirling Arcane Essence
            questId: 95049,
            source: 'Disenchanting',
        },
        {
            itemId: 267654, // Swirling Arcane Essence
            questId: 95050,
            source: 'Disenchanting',
        },
        {
            itemId: 267654, // Swirling Arcane Essence
            questId: 95051,
            source: 'Disenchanting',
        },
        {
            itemId: 267654, // Swirling Arcane Essence
            questId: 95052,
            source: 'Disenchanting',
        },
        {
            itemId: 267655, // Brimming Mana Shard
            questId: 95053,
            source: 'Disenchanting',
        },
    ],
    bookQuests: [
        {
            itemId: 250445, // Echo of Abundance: Enchanting
            questId: 92186,
            source: 'AB',
        },
        {
            itemId: 257600, // Skill Issue: Enchanting
            questId: 92374,
            source: 'SC 6',
        },
        {
            itemId: 274511, // Demystifyin'
            questId: 96512,
            source: 'ZF 6', // Zul'jarra's Forces
        },
    ],
};

const warWithinTaskQuests = [
    84084, // Just a Pinch
    84085, // The Power of Potential
    84086, // A Rare Necessity
];

export const warWithinEnchanting: TaskProfession = {
    id: Profession.Enchanting,
    subProfessionId: 2874,
    treatiseQuest: {
        itemId: 222550, // Algari Treatise on Enchanting
        questId: 83727,
    },
    taskQuests: warWithinTaskQuests.map((questId) => ({
        itemId: 227667, // Algari Enchanter's Folio
        questId,
    })),
    dropQuests: [
        {
            itemId: 225230, // Crystalline Repository
            questId: 83259,
            source: 'Mobs/Treasures',
        },
        {
            itemId: 225231, // Powdered Fulgurance
            questId: 83258,
            source: 'Mobs/Treasures',
        },
    ],
    gatherQuests: [
        {
            itemId: 227659, // Fleeting Arcane Manifestation
            questId: 84290,
            source: 'Disenchanting',
        },
        {
            itemId: 227659, // Fleeting Arcane Manifestation
            questId: 84291,
            source: 'Disenchanting',
        },
        {
            itemId: 227659, // Fleeting Arcane Manifestation
            questId: 84292,
            source: 'Disenchanting',
        },
        {
            itemId: 227659, // Fleeting Arcane Manifestation
            questId: 84293,
            source: 'Disenchanting',
        },
        {
            itemId: 227659, // Fleeting Arcane Manifestation
            questId: 84294,
            source: 'Disenchanting',
        },
        {
            itemId: 227661, // Gleaming Telluric Crystal
            questId: 84295,
            source: 'Disenchanting',
        },
    ],
    bookQuests: [
        {
            itemId: 227411, // Faded Enchanter's Research
            questId: 81076,
            source: 'AC',
            costs: [{ amount: 200, itemId: 210814 }], // Artisan's Acuity
        },
        {
            itemId: 227422, // Exceptional Enchanter's Research
            questId: 81077,
            source: 'AC',
            costs: [{ amount: 300, itemId: 210814 }], // Artisan's Acuity
        },
        {
            itemId: 227433, // Pristine Enchanter's Research
            questId: 81078,
            source: 'AC',
            costs: [{ amount: 400, itemId: 210814 }], // Artisan's Acuity
        },
        {
            itemId: 224652, // Jewel-Etched Enchanting Notes
            questId: 83060,
            source: 'CoD 12',
            costs: [{ amount: 50, itemId: 210814 }], // Artisan's Acuity
        },
        {
            itemId: 224050, // Web Sparkles: Pretty and Powerful
            questId: 82635,
            source: 'CoT',
            costs: [{ amount: 565, currencyId: 3056 }], // Kej
        },
        {
            itemId: 232501, // Undermine Treatise on Enchanting
            questId: 85736,
            source: 'UM 16',
            costs: [{ amount: 50, itemId: 210814 }], // Artisan's Acuity
        },
        {
            itemId: 235863, // Ethereal Tome of Enchanting Knowledge
            questId: 87265,
            source: 'TV 12',
            costs: [{ amount: 50, itemId: 210814 }], // Artisan's Acuity
        },
    ],
    treasureQuests: [],
};

const enchantersScriptQuest = (questId: number) => ({
    itemId: 198610,
    questId,
});
const dragonflightProvideQuests = [
    72155, // Spread the Enchantment
    72172, // Essence, Shards, and Chromatic Dust
    72173, // Braced for Enchantment
    72175, // A Scept-acular Time
];
const dragonflightTaskQuests = [
    66884, // Fireproof Gear
    66900, // Enchanted Relics
    66935, // Crystal Quill Pens
    72423, // Weathering the Storm
    75150, // [ZC] Incandescence
    75865, // [ZC] Relic Rustler
    77910, // [ED] Enchanted Shrubbery
    77937, // [ED] Forbidden Sugar
];

export const dragonflightEnchanting: TaskProfession = {
    id: Profession.Enchanting,
    subProfessionId: 2825,
    masterQuestId: 70251,
    treatiseQuest: {
        itemId: 194702, // Draconic Treatise on Enchanting
        questId: 74110,
    },
    provideQuests: dragonflightProvideQuests.map(enchantersScriptQuest),
    taskQuests: dragonflightTaskQuests.map(enchantersScriptQuest),
    dropQuests: [
        {
            itemId: 193900, // Prismatic Focusing Shard
            questId: 66377,
            source: 'Treasures',
        },
        {
            itemId: 193901, // Primal Dust
            questId: 66378,
            source: 'Treasures',
        },
        {
            itemId: 198967, // Primordial Aether
            questId: 70514,
            source: 'Mobs: Arcane',
        },
        {
            itemId: 198968, // Primalist Charm
            questId: 70515,
            source: 'Mobs: Primalist',
        },
        {
            itemId: 204224, // Speck of Arcane Awareness
            questId: 74306,
            source: 'FR: Manathema',
        },
    ],
    bookQuests: [
        {
            itemId: 200976, // Artisan's Consortium, Preferred
            questId: 71895,
            source: 'AC 2',
        },
        {
            itemId: 201272, // Artisan's Consortium, Valued
            questId: 71906,
            source: 'AC 4',
        },
        {
            itemId: 201283, // Artisan's Consortium, Esteemed
            questId: 71917,
            source: 'AC 5',
        },
        {
            itemId: 201709, // Notebook of Crafting Knowledge
            questId: 72299, // Expedition Crafting Knowledge
            source: 'DE 14',
        },
        {
            itemId: 201709, // Notebook of Crafting Knowledge
            questId: 72304, // Expedition Crafting Knowledge
            source: 'DE 23',
        },
        {
            itemId: 201709, // Notebook of Crafting Knowledge
            questId: 72318, // Iskaaran Crafter's Knowledge
            source: 'IT 14',
        },
        {
            itemId: 201709, // Notebook of Crafting Knowledge
            questId: 72323, // Iskaaran Crafting Mastery
            source: 'IT 24',
        },
        {
            itemId: 205351, // Niffen Notebook of Enchanting Knowledge
            questId: 75752,
            source: 'LN',
        },
        {
            itemId: 205438, // Bartered Enchanting Journal
            questId: 75850,
            source: 'ZCB',
        },
        {
            itemId: 205427, // Bartered Enchanting Notes
            questId: 75845,
            source: 'ZCB',
        },
    ],
    treasureQuests: [
        {
            itemId: 201012, // Enchanted Debris
            questId: 70272,
            source: 'WS',
        },
        {
            itemId: 198694, // Enriched Earthen Shard
            questId: 70298,
            source: 'AS',
        },
        {
            itemId: 201013, // Faintly Enchanted Remains
            questId: 70290,
            source: 'AS',
        },
        {
            itemId: 198798, // Flashfrozen Scroll
            questId: 70320,
            source: 'WS',
        },
        {
            itemId: 198799, // Forgotten Arcane Tome
            questId: 70336,
            source: 'AS',
        },
        {
            itemId: 198800, // Fractured Titanic Sphere
            questId: 70342,
            source: 'TD',
        },
        {
            itemId: 204990, // Lava-Drenched Shadow Crystal
            questId: 75508,
            source: 'ZC',
        },
        {
            itemId: 198675, // Lava-Infused Seed
            questId: 70283,
            source: 'WS',
        },
        {
            itemId: 205001, // Resonating Arcane Crystal
            questId: 75510,
            source: 'ZC',
        },
        {
            itemId: 204999, // Shimmering Aqueous Orb
            questId: 75509,
            source: 'ZC',
        },
        {
            itemId: 198689, // Stormbound Horn
            questId: 70291,
            source: 'OP',
        },
        {
            itemId: 210234, // Essence of Dreams
            questId: 78310,
            source: 'ED',
        },
        {
            itemId: 210231, // Everburning Core
            questId: 78309,
            source: 'ED',
        },
        {
            itemId: 210228, // Pure Dream Water
            questId: 78308,
            source: 'ED',
        },
    ],
};
